import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import CS from '@/styles/componentStyled';
import TitleTextBox from '@/component/TitleTextBox';
import { dashboardFacilityRecoil } from '@/atom/DashboardAtom';

const AllDevice = () => {
  const dashboardFacilityState = useRecoilValue(dashboardFacilityRecoil);

  return (
    <>
      <CntBox className="flex fdc">
        <TitleTextBox text="전체 디바이스" />
        <ul className="flex">
          <li className="flex fdc rel">
            <span className="img-box abs">
              <img src="/img/ico_device_blue.svg" alt="" />
            </span>
            <h3 className="lh140 tm">전체 디바이스</h3>
            <p className="tb">
              {dashboardFacilityState?.totalDevice.toLocaleString()}
            </p>
          </li>
          <li className="flex fdc rel">
            <span className="img-box abs">
              <img src="/img/ico_device_red.svg" alt="" />
            </span>
            <h3 className="lh140 tm">이상 디바이스</h3>
            <p className="tb">
              {dashboardFacilityState?.errorDevice.toLocaleString()}
            </p>
          </li>
          <li className="flex fdc rel">
            <span className="img-box abs">
              <img src="/img/ico_device_yellow.svg" alt="" />
            </span>
            <h3 className="lh140 tm">통신 실패</h3>
            <p className="tb">
              {dashboardFacilityState?.communicationError.toLocaleString()}
            </p>
          </li>
        </ul>
      </CntBox>
    </>
  );
};

export default AllDevice;

export const CntBox = styled(CS.CntBoxType1)`
  flex: 1 1 0%;
  gap: 50px;
  > ul {
    gap: 12px;
    height: 120px;
    > li {
      flex-grow: 1;
      height: 100%;
      background: #f9f9f9;
      border-radius: 12px;
      box-sizing: border-box;
      padding: 36px 0 20px 20px;
      > .img-box {
        width: 56px;
        top: -34px;
        left: 8px;
      }
      > h3 {
        font-size: 16px;
        color: #555555;
      }
      > p {
        font-size: 28px;
        color: #222;
        margin-top: 6px;
      }
    }
  }
  @media (max-width: 1420px) {
    gap: 50px !important;
  }
`;
